function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "#000"
    },
    viewBox: "55.5 55.5 314.1 344.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M55.547 212.6c0 86.74 70.313 157.05 157.05 157.05 86.74 0 157.05-70.31 157.05-157.05s-70.31-157.05-157.05-157.05c-86.74-.003-157.05 70.31-157.05 157.05",
    style: {
      fill: "#dc8ff1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.45 176.5c-.79-1.85-1.75-3.72-2.77-5.63-2-3.77-4.75-7.05-5.12-11.39-.34-4.01 1.49-7.85 1.5-11.98.01-10.71-5.43-15.21-13-21.02-7.07-5.43-5.5-16.61-12.53-22.4-3.64-3.01-6.74-1.81-10.36-3.71-3.1-1.64-5.96-6.386-9.01-8.518-8.17-5.707-11.67-3-20.6-1.348-8 1.48-14.41-3.77-22-5.637-8.69-2.137-16.15.324-24.5 2.488-8.06 2.086-17.38-1.746-25 1.235-7.4 2.89-9.27 13.07-12.89 19-4.85 7.94-15.53 11.27-22.11 17.5-4.24 4-3.76 5.91-4.5 10.89-.6 4.03-2.62 7.33-4.63 11-3.82 6.99-7.88 15.5-4.01 23.52 1.74 3.61 3.72 4.61 4.14 8.98.4 4.11-.76 8.23-1.47 12-1 5.29-1.05 7.49 1.96 12.01 2.41 3.63 3.47 5.62 4.4 9.99.77 3.63 1.25 7.75 4.23 10.37 3.45 3.03 6.01 2.66 8.25 7.24 4.18 8.49 4.67 14.29 14.13 18.4 7.15 3.11 8.73 12.26 16.5 13.49 8.69 1.37 15.35-.84 23.5 3.12 3.86 1.88 6.95 3.02 11 3.86 15.8 3.29 31.74 3.35 46.39-5.21 6.78-3.96 15.71-5.28 18.12-13.77 2.4-8.48 9.4-10.71 15.98-16.02 6.5-5.25 9.73-10.76 10.12-18.1.47-8.84 10-14.61 14.25-22.38 3.51-6.42 2.56-12.1.03-17.98",
    style: {
      fill: "#331520"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.23 370.08a152.284 152.284 0 0 1-28.96 17.01c-19.13 8.58-40.34 13.35-62.67 13.35s-43.53-4.77-62.66-13.35c-1.37-.61-2.72-1.23-4.05-1.88-8.81-4.26-17.15-9.33-24.91-15.13 1.36-30.36 17.49-56.88 41.38-72.54 14.43-9.47 31.69-14.97 50.24-14.97 2.83 0 5.63.13 8.38.38a91.043 91.043 0 0 1 41.86 14.59c11 7.21 20.35 16.72 27.37 27.84 8.24 13.05 13.27 28.32 14.02 44.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.84 297.54a50.44 50.44 0 0 1-12.98 27.64c-9.26 10.03-22.52 16.32-37.26 16.32-23.61 0-43.45-16.15-49.08-38.01-.5-1.94-.89-3.93-1.16-5.95 14.43-9.47 31.69-14.97 50.24-14.97 2.83 0 5.63.12 8.39.38.48.04.96.09 1.43.14.3.03.6.06.89.1.33.03.66.08.98.12.2.02.41.05.61.08.29.03.59.08.89.12.23.03.46.07.7.1.2.03.4.06.6.1.34.05.67.11 1.01.16 1.46.25 2.91.53 4.34.85l.96.21c.18.05.37.09.55.14.34.08.69.16 1.02.25.06.01.11.02.15.03.43.11.86.22 1.28.34.46.11.91.24 1.35.37.51.14 1.01.29 1.52.44.39.12.78.24 1.17.37.25.08.51.16.75.24.41.13.82.27 1.22.41.5.17.99.34 1.48.52.04.02.07.03.1.04.51.18 1.01.37 1.51.56.37.15.75.29 1.13.45.99.39 1.96.8 2.92 1.22l1.26.57c.38.17.76.35 1.14.53.35.17.69.33 1.03.5.32.15.63.31.94.47.2.1.41.2.61.31a80.233 80.233 0 0 1 3.31 1.79c.19.11.37.21.55.31l.68.4.69.42.45.27c.43.25.85.51 1.27.78.46.29.91.58 1.36.88",
    style: {
      fill: "#ba5c21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.26 262.02v34.74c0 8.79-7.19 15.99-15.97 15.99h-3.38c-8.78 0-15.96-7.2-15.96-15.99v-34.74c0-8.79 7.18-15.98 15.96-15.98h3.38c8.78 0 15.97 7.19 15.97 15.98",
    style: {
      fill: "#ba5c21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.26 262.02v18.38c-5.25 2.92-10.82 4.62-16.47 4.62-6.67 0-13.03-1.86-18.84-5.09v-17.91c0-8.79 7.18-15.98 15.96-15.98h3.38c8.78 0 15.97 7.19 15.97 15.98",
    style: {
      fill: "#9e392b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.05 240.48s10.46-3.56 17.14-15.22c7.26-12.66 2.7-20.55 1.26-22.26-3.93-4.67-10-1.67-11 0s-15.48 27.97-7.4 37.48",
    style: {
      fill: "#ba5c21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3 207.15s6.64.85 4.31 10.18c-2.34 9.34-8.47 13.03-16.81 17.8-8.33 4.77 4.17-26.08 12.5-27.98",
    style: {
      fill: "#9e392b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.87 240.48s-10.46-3.56-17.14-15.22c-7.27-12.66-2.71-20.55-1.27-22.26 3.93-4.67 10-1.67 11 0s15.49 27.97 7.41 37.48",
    style: {
      fill: "#ba5c21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.61 207.15s-6.63.85-4.3 10.18c2.33 9.34 8.47 13.03 16.8 17.8 8.34 4.77-4.16-26.08-12.5-27.98",
    style: {
      fill: "#9e392b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3 200.99c0-38.33-28.29-69.41-63.2-69.41-34.9 0-63.21 31.08-63.21 69.41s28.31 78.4 63.21 78.4c32.8 0 63.2-40.39 63.2-78.4",
    style: {
      fill: "#ba5c21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.37 131.58s1.67-7.24-4.33-12.91-85.45 5.97-66.56 82.32c0 0 18.51-45.66 67.56-49.66l3.33-19.75",
    style: {
      fill: "#331520"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.79 131.58s-1.66-7.24 4.34-12.91 85.44 5.97 66.56 82.32c0 0-18.52-45.66-67.56-49.66l-3.34-19.75",
    style: {
      fill: "#331520"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.9b192cdce0f16346e25a58845421d102.svg";
export { ForwardRef as ReactComponent };